import { Files, Settings } from "lucide-react";
import { BrandMark } from "../components/BrandMark.js";
import { LocaleToggle } from "../components/LocaleToggle.js";
import { useI18n } from "../lib/i18n.js";

export function HomePage() {
  const { t } = useI18n();
  return (
    <main className="vault-home">
      <header className="topbar">
        <BrandMark />
        <LocaleToggle />
      </header>
      <section className="home-center">
        <div className="handoff-orbit" aria-hidden="true">
          <span className="transfer-pulse one" />
          <span className="transfer-pulse two" />
          <span className="transfer-line top" />
          <span className="transfer-line bottom" />
          <Files size={42} />
        </div>
        <h1>{t("homeTitle")}</h1>
        <p>{t("homeSubtitle")}</p>
        <a className="primary-button" href="/admin">
          <Settings size={18} />
          {t("openAdmin")}
        </a>
      </section>
    </main>
  );
}
